import React from "react"
import styled from "@emotion/styled"
import Button from "../Button/button"

import "./promotionalOffer.scss"

const promotionalOffer = props => {
  const PromotionalOfferWrapper = styled("div")`
    &.light {
      h2 {
        color: #000;
      }
      .body-copy,
      .text-block__promotion,
      .disclaimer {
        p,
        a {
          color: #000;
        }
      }
    }
  `

  return (
    <PromotionalOfferWrapper className={`text-block ${props.color_theme}`}>
      <div className="container">
        <h2 className="headline"> {props.headline} </h2>
        {props.promotional_text !== null &&
          props.promotional_text !== undefined &&
          props.promotional_text[0] && (
            <div className="text-block__promotion">
              <h5>
                {props.promotional_text[0].mkt_copy}
                <br />
                {props.promotional_text[0].subhead}
              </h5>
            </div>
          )}
        <div
          className="body-copy"
          dangerouslySetInnerHTML={{ __html: props.body_copy }}
        />
        {props.button.length !== 0 && (
          <div className="button__container">
            {props.button.map((data, index) => (
              <Button
                key={index}
                button_link={data.button_link.href}
                button_link_type={data.button_link_type}
                button_text={data.button_text}
                button_color={data.button_color}
                button_type={data.button_type}
                className={
                  data.button_type === "square button" && "button__sign-up"
                }
                color_theme={props.color_theme}
                text_color={data.text_color}
              />
            ))}
          </div>
        )}
        {props.promotional_text !== null &&
          props.promotional_text !== undefined &&
          props.promotional_text[0] && (
            <>
              <p className="disclaimer">
                {props.promotional_text[0].legal_copy}
              </p>
            </>
          )}
      </div>
    </PromotionalOfferWrapper>
  )
}

export default promotionalOffer
